import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Breadcrumb from 'components/consumer/consumer-breadcrumb';
import usePDPBreadcrumbs from 'data-hooks/usePDPBreadcrumbs';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
const PDPBreadCrumbsInner = t0 => {
  const $ = _c(7);
  const {
    shortened: t1
  } = t0;
  const shortened = t1 === undefined ? false : t1;
  const breadCrumbData = usePDPBreadcrumbs();
  let t2;
  if ($[0] !== breadCrumbData.data || $[1] !== shortened) {
    t2 = shortened && breadCrumbData.data.length > 2 ? [breadCrumbData.data[0], breadCrumbData.data.at(-1)] : breadCrumbData.data;
    $[0] = breadCrumbData.data;
    $[1] = shortened;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const items = t2;
  let t3;
  if ($[3] !== breadCrumbData || $[4] !== items || $[5] !== shortened) {
    t3 = !isEmpty(breadCrumbData) ? <><MobileAndTabletOnly><div className="lg:hidden"><Breadcrumb color="dark" forPage="PDPMobile" config={{
            items
          }} withSchema={!shortened} /></div></MobileAndTabletOnly><DesktopOnly><div className="max-[1023px]:hidden"><Breadcrumb color="light" forPage="PDP" config={{
            items
          }} withSchema={!shortened} /></div></DesktopOnly></> : null;
    $[3] = breadCrumbData;
    $[4] = items;
    $[5] = shortened;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
PDPBreadCrumbsInner.propTypes = {
  shortened: PropTypes.bool
};
const PDPBreadCrumbs = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPBreadCrumbsInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPBreadCrumbs;